
//Custom hook for accessing AppContext in components

import {useContext} from 'react';
import Context from './context';


const useInfoCardSectionContext = () => useContext(Context);

export default useInfoCardSectionContext;